import { Box, Button, Stack, TextField } from '@mui/material'
import { useState } from 'react'
import { CreateLabelMasterDialog } from './CreateLabelMasterDialog'

type Props = {
  keyword: string
  keywordError: string | undefined
  onChangeKeyword: (keyword: string) => void
  onSearch: () => void
}

export const ListControls = ({
  keyword,
  keywordError,
  onChangeKeyword,
  onSearch,
}: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <Stack
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      px={3}
      flexWrap="wrap"
    >
      <Box sx={{ width: 400 }}>
        <TextField
          placeholder="ラベルマスタ名またはラベルマスタ管理番号"
          variant="outlined"
          value={keyword}
          size="small"
          fullWidth
          error={!!keywordError}
          helperText={keywordError}
          onChange={e => onChangeKeyword(e.target.value)}
          onBlur={onSearch}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              onSearch()
            }
          }}
          sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white' } }}
        />
      </Box>
      <Button variant="contained" onClick={() => setDialogOpen(true)}>
        新規登録
      </Button>
      {dialogOpen && (
        <CreateLabelMasterDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
        />
      )}
    </Stack>
  )
}
